/**
 * The rows of the background-music catalogue.
 *
 * ---------------------------------------------------------------------------
 * GENERATED FILE — do not edit by hand.
 *   node scripts/import-bg-music.mjs
 * ---------------------------------------------------------------------------
 *
 * One row per track, with **every bundled file statically `require()`d** —
 * Metro cannot resolve a path at runtime, so a track that is not named here does
 * not exist — and every `durationMs` measured from the audio itself, so the
 * length a creator reads in the list is the length they hear.
 *
 * To seed it, in bulk: `pnpm music:import` (see `scripts/music/import.mjs`),
 * which downloads licence-checked tracks, normalises them and edits
 * `assets/sounds/music/music-manifest.json`. To seed it by hand: drop the
 * instrumentals into `assets/sounds/music/`, describe them in the manifest, and
 * run this script. Every row is a file under `assets/sounds/`, so a bed never
 * streams from a host; a manifest row that names a `url` is refused.
 *
 * 51 tracks.
 */

import {type MusicTrack} from '#/lib/backgroundMusic'

export const MUSIC_LIBRARY: MusicTrack[] = [
  {
    id: 'bed-06-peace-of-my-heart',
    title: '06. Peace OF My Heart',
    category: 'energetic',
    durationMs: 179513,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/06-peace-of-my-heart.mp3'),
    },
  },
  {
    id: 'bed-am-very-happy-today',
    title: 'Am Very Happy Today',
    category: 'happy',
    durationMs: 256183,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/am-very-happy-today.mp3'),
    },
  },
  {
    id: 'bed-at-the-lounge',
    title: 'At The Lounge',
    category: 'calm',
    durationMs: 228598,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/at-the-lounge.mp3'),
    },
  },
  {
    id: 'bed-back-to-peace',
    title: 'Back to peace',
    category: 'happy',
    durationMs: 181969,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/back-to-peace.mp3'),
    },
  },
  {
    id: 'bed-calm-after-war',
    title: 'Calm after war',
    category: 'calm',
    durationMs: 222171,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/calm-after-war.mp3'),
    },
  },
  {
    id: 'bed-calme',
    title: 'Calme',
    category: 'focus',
    durationMs: 228023,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/calme.mp3'),
    },
  },
  {
    id: 'bed-chai',
    title: 'chai',
    category: 'calm',
    durationMs: 214073,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/chai.mp3'),
    },
  },
  {
    id: 'bed-chill',
    title: 'Chill',
    category: 'cinematic',
    durationMs: 155925,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/chill.mp3'),
    },
  },
  {
    id: 'bed-chill-rock',
    title: 'chill rock',
    category: 'ambient',
    durationMs: 220839,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/chill-rock.mp3'),
    },
  },
  {
    id: 'bed-chilling-with-the-mpc',
    title: 'chilling with the MPC',
    category: 'soft',
    durationMs: 154645,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/chilling-with-the-mpc.mp3'),
    },
  },
  {
    id: 'bed-dark-moment-dark-epic-trailer',
    title: 'Dark Moment - Dark Epic Trailer',
    category: 'cinematic',
    durationMs: 96183,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/dark-moment-dark-epic-trailer.mp3'),
    },
  },
  {
    id: 'bed-downtempo-mix-track-4',
    title: 'DownTempo Mix Track 4',
    category: 'lofi',
    durationMs: 199784,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/downtempo-mix-track-4.mp3'),
    },
  },
  {
    id: 'bed-dub-n-chill-by-steven-booth',
    title: "Dub 'n' Chill by Steven Booth",
    category: 'energetic',
    durationMs: 152607,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/dub-n-chill-by-steven-booth.mp3'),
    },
  },
  {
    id: 'bed-eaux-calmes',
    title: 'Eaux calmes',
    category: 'ambient',
    durationMs: 237949,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/eaux-calmes.mp3'),
    },
  },
  {
    id: 'bed-energetic-fan-dance-adeline-yeo-hp-edited',
    title: 'Energetic Fan Dance - Adeline Yeo (HP) Edited',
    category: 'energetic',
    durationMs: 179540,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/energetic-fan-dance-adeline-yeo-hp-edited.mp3'),
    },
  },
  {
    id: 'bed-first-autumn-chill-by-steven-booth',
    title: 'First Autumn Chill by Steven Booth',
    category: 'ambient',
    durationMs: 259239,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/first-autumn-chill-by-steven-booth.mp3'),
    },
  },
  {
    id: 'bed-fusion-dark-epic-trailer',
    title: 'Fusion - Dark Epic Trailer',
    category: 'cinematic',
    durationMs: 97489,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/fusion-dark-epic-trailer.mp3'),
    },
  },
  {
    id: 'bed-happiness',
    title: 'happiness',
    category: 'calm',
    durationMs: 248320,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/happiness.mp3'),
    },
  },
  {
    id: 'bed-happy-ending',
    title: 'Happy Ending',
    category: 'happy',
    durationMs: 181812,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/happy-ending.mp3'),
    },
  },
  {
    id: 'bed-happy-ever-after-instrumental',
    title: 'Happy Ever After instrumental',
    category: 'happy',
    durationMs: 230322,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/happy-ever-after-instrumental.mp3'),
    },
  },
  {
    id: 'bed-happy-new-year-2008',
    title: 'Happy new year (2008)',
    category: 'ambient',
    durationMs: 262896,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/happy-new-year-2008.mp3'),
    },
  },
  {
    id: 'bed-heaviness-dark-epic-trailer',
    title: 'Heaviness - Dark Epic Trailer',
    category: 'cinematic',
    durationMs: 76591,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/heaviness-dark-epic-trailer.mp3'),
    },
  },
  {
    id: 'bed-indicazo-inner-peace',
    title: 'Indicazo - Inner peace',
    category: 'ambient',
    durationMs: 235154,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/indicazo-inner-peace.mp3'),
    },
  },
  {
    id: 'bed-infinite-mind-relax',
    title: 'Infinite Mind Relax',
    category: 'calm',
    durationMs: 130926,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/infinite-mind-relax.mp3'),
    },
  },
  {
    id: 'bed-kool-chill-by-steven-booth',
    title: 'Kool Chill by Steven Booth',
    category: 'ambient',
    durationMs: 234762,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/kool-chill-by-steven-booth.mp3'),
    },
  },
  {
    id: 'bed-landscape',
    title: 'Landscape',
    category: 'happy',
    durationMs: 227605,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/landscape.mp3'),
    },
  },
  {
    id: 'bed-like-a-sentimental-movie',
    title: 'Like A Sentimental Movie',
    category: 'focus',
    durationMs: 153626,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/like-a-sentimental-movie.mp3'),
    },
  },
  {
    id: 'bed-lofi-house',
    title: 'Lofi House',
    category: 'lofi',
    durationMs: 123742,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/lofi-house.mp3'),
    },
  },
  {
    id: 'bed-lounge',
    title: 'Lounge',
    category: 'focus',
    durationMs: 156500,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/lounge.mp3'),
    },
  },
  {
    id: 'bed-music-for-relaxation-to-night',
    title: 'Music for relaxation (to night)',
    category: 'happy',
    durationMs: 160967,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/music-for-relaxation-to-night.mp3'),
    },
  },
  {
    id: 'bed-never-give-up',
    title: 'Never Give Up',
    category: 'cinematic',
    durationMs: 103210,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/never-give-up.mp3'),
    },
  },
  {
    id: 'bed-night-voyage-chill-mix',
    title: 'Night Voyage (Chill Mix)',
    category: 'focus',
    durationMs: 226038,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/night-voyage-chill-mix.mp3'),
    },
  },
  {
    id: 'bed-no-sentiments',
    title: 'No sentiments',
    category: 'energetic',
    durationMs: 131396,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/no-sentiments.mp3'),
    },
  },
  {
    id: 'bed-other-dimension-chill-pill-mix-the-diventa-project',
    title: 'Other Dimension(Chill Pill Mix) - (The Diventa Project)',
    category: 'lofi',
    durationMs: 194534,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/other-dimension-chill-pill-mix-the-diventa-project.mp3'),
    },
  },
  {
    id: 'bed-parpg-ruins-calm-amibient',
    title: 'PARPG Ruins (Calm, Amibient)',
    category: 'ambient',
    durationMs: 216607,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/parpg-ruins-calm-amibient.mp3'),
    },
  },
  {
    id: 'bed-peace-at-war',
    title: 'Peace at war',
    category: 'focus',
    durationMs: 248503,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/peace-at-war.mp3'),
    },
  },
  {
    id: 'bed-peaceful',
    title: 'Peaceful',
    category: 'calm',
    durationMs: 143621,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/peaceful.mp3'),
    },
  },
  {
    id: 'bed-peaceful-stress-relief-harp',
    title: 'Peaceful Stress Relief Harp',
    category: 'calm',
    durationMs: 208274,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/peaceful-stress-relief-harp.mp3'),
    },
  },
  {
    id: 'bed-relaxer',
    title: 'Relaxer',
    category: 'lofi',
    durationMs: 185548,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/relaxer.mp3'),
    },
  },
  {
    id: 'bed-rough-but-peacful',
    title: 'Rough but peacful',
    category: 'focus',
    durationMs: 150309,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/rough-but-peacful.mp3'),
    },
  },
  {
    id: 'bed-san-telmo-lounge',
    title: 'San Telmo Lounge',
    category: 'ambient',
    durationMs: 242077,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/san-telmo-lounge.mp3'),
    },
  },
  {
    id: 'bed-sentimental-value',
    title: 'Sentimental Value',
    category: 'soft',
    durationMs: 140487,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/sentimental-value.mp3'),
    },
  },
  {
    id: 'bed-silence',
    title: 'Silence',
    category: 'soft',
    durationMs: 147827,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/silence.mp3'),
    },
  },
  {
    id: 'bed-so-happy',
    title: 'So Happy',
    category: 'focus',
    durationMs: 243252,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/so-happy.mp3'),
    },
  },
  {
    id: 'bed-soft-drift',
    title: 'Soft Drift',
    category: 'soft',
    durationMs: 8000,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/bg-music.wav'),
    },
  },
  {
    id: 'bed-the-lounge-piano-version',
    title: 'The Lounge ! (Piano Version)',
    category: 'happy',
    durationMs: 176901,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/the-lounge-piano-version.mp3'),
    },
  },
  {
    id: 'bed-the-pink-ribbon-lounge',
    title: 'the pink ribbon lounge',
    category: 'focus',
    durationMs: 241842,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/the-pink-ribbon-lounge.mp3'),
    },
  },
  {
    id: 'bed-the-ride-of-the-dark-knight',
    title: 'The ride of the Dark Knight',
    category: 'cinematic',
    durationMs: 186201,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/the-ride-of-the-dark-knight.mp3'),
    },
  },
  {
    id: 'bed-this-world-is-full-of-epic',
    title: 'This World is Full of Epic',
    category: 'energetic',
    durationMs: 173871,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/this-world-is-full-of-epic.mp3'),
    },
  },
  {
    id: 'bed-une-journee-calme',
    title: 'Une journée calme',
    category: 'soft',
    durationMs: 157544,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/une-journee-calme.mp3'),
    },
  },
  {
    id: 'bed-world-peace',
    title: 'World Peace',
    category: 'calm',
    durationMs: 236016,
    source: {
      kind: 'bundled',
      module: require('../../assets/sounds/music/world-peace.mp3'),
    },
  },
]
